<template>
  <div v-if="label != null" ref="element" class="PictureObject">
    <CollectorComponents
      v-for="(child, i) in src._children"
      @resize="label.resize"
      :parentOffset="label.offset"
      :src="child"
      :type="child._tipo"
      :key="i"
    />
  </div>
</template>
<script>
import LabelComponent from "@/classes/LabelComponent.js";

export default {
  name: "LineObject",
  props: {
    src: Object,
    parentOffset: Object,
  },
  components: {
    CollectorComponents: () => import("./CollectorComponents.vue"),
  },
  data() {
    return {
      label: null,
    };
  },
  methods: {},
  mounted() {
    this.label = new LabelComponent(this);
    this.$nextTick(() => {
      const style = {
        backgroundColor: "black",
        border: `1px solid black`,
        display: "inline-block",
        height: this.src.Height === null ? "0mm" : this.src.Height + "px",
        left: this.src.Left === null ? "0px" : this.src.Left + "px",
        position: "absolute",
        top: this.src.Top === null ? "0px" : this.src.Top + "px",
        width: this.src.Width === null ? "0px" : this.src.Width + "px",
        zIndex: 9,
        boxSizing: "border-box",
      };
      this.label.getStyle(style);
      this.label.rendered = true;
    });
  },
};
</script>
